import React, { ReactNode } from "react";
import { Container, ContainerProps, useMediaQuery } from "@mui/material"; // Assuming you're using Material-UI's Container
import { theme } from "../app/theme";

interface CustomContainerProps extends ContainerProps {
  children: ReactNode;
}

const CustomContainer: React.FC<CustomContainerProps> = ({
  children,
  sx,
  ...rest
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Container
      maxWidth={false}
      sx={{
        position: "relative",
        marginTop: isMobile ? "-24rem" : "-18rem",
        marginBottom: "20rem",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Container>
  );
};

export default CustomContainer;
